export const ON_MOUNT_NEWSLETTERS = 'ON_MOUNT_NEWSLETTERS';
export const GET_NEWSLETTERS = 'GET_NEWSLETTERS';
export const DELETE_NEWSLETTERS = 'DELETE_NEWSLETTERS';
export const UNPUBLISH_NEWSLETTERS = 'UNPUBLISH_NEWSLETTERS';
